// extracted by mini-css-extract-plugin
export var ldsEllipsis = "styles-module__ldsEllipsis___Qk5eZ";
export var ldsEllipsis1 = "styles-module__lds-ellipsis1___EXGnN";
export var ldsEllipsis2 = "styles-module__lds-ellipsis2___lYiMF";
export var ldsEllipsis3 = "styles-module__lds-ellipsis3___HqLLo";